import React from 'react';
import { Col, Grid, Row, Typography } from 'antd';
import classNames from 'classnames';

import ImageC from 'src/components/Image';
import CollapsibleList from 'src/components/TerapiRegeneratif/CollapsibleList';
import panelsData from 'src/utils/dummy/stemcell/faq';

import classes from './index.module.less';

const FAQ = () => {
	const { md, xxl } = Grid.useBreakpoint();

	return (
		<div className="bg-white py-5">
			<div className={classNames('container', classes.faq)}>
				{md && (
					<Typography.Title level={2} className={classes.title}>
						FAQ
					</Typography.Title>
				)}
				<Row gutter={{ md: 60, xs: 0 }}>
					{!md && (
						<Col className="d-flex justify-content-center" xs={24}>
							<div>
								<ImageC
									objectFit="cover"
									width={400}
									height={400}
									src="/images/stem-cell/cells-square.png"
								/>
							</div>
						</Col>
					)}
					<Col md={12} xs={24}>
						{!md && (
							<Typography.Title level={2} className={classes.title}>
								FAQ
							</Typography.Title>
						)}
						<CollapsibleList panels={panelsData} />
					</Col>
					{md && (
						<Col className="d-flex justify-content-center" md={12}>
							<div>
								<ImageC
									objectFit="cover"
									width={xxl ? 550 : 400}
									height={xxl ? 550 : 400}
									src="/images/stem-cell/cells-square.png"
								/>
							</div>
						</Col>
					)}
				</Row>
			</div>
		</div>
	);
};

export default FAQ;
